import { forwardRef, useImperativeHandle } from 'react';

import { CenteredLoaderDots } from '@xemplo/loader';
import { Modal, useModalDialog } from '@xemplo/modal-dialog';
import { useGetPayrunByIdQuery } from '@xemplo/payrun-query';

import { ModalDialogRef } from '../edit-payrun-milestones.types';

import { EditMilestonesContent } from './edit-milestones-content';

export interface EditMilestonesModalProps {
  payrunId: string;
}

export const EditMilestonesModal = forwardRef<ModalDialogRef, EditMilestonesModalProps>(
  (props, ref) => {
    const { payrunId } = props;
    const modalDialog = useModalDialog({
      id: 'edit-payrun-milestones-modal',
    });
    useImperativeHandle(ref, () => modalDialog, [modalDialog]);

    // Ensure all data is fully loaded before initialising the form
    const { data: payrun, isLoading } = useGetPayrunByIdQuery({ id: payrunId });
    if (isLoading) return <CenteredLoaderDots />;
    if (!payrun?.result) return null;

    return (
      <Modal.Dialog {...modalDialog.dialogProps}>
        {modalDialog.isOpen && (
          <EditMilestonesContent
            modalDialog={modalDialog}
            payrunId={payrunId}
            payrun={payrun.result}
          />
        )}
      </Modal.Dialog>
    );
  },
);
